module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAARFJREFUWEftV8Ftg0AQnJX42yWYx+43TgVxOnEpKSElJJXE7gB/7x5QgvkjTXQIMMSWJdtg8rh9Id2xMxp2uDnBzCUz4yMSOFPAObcWkcUUn4ZkaWZZv3dHoAH+AbCcArzX80jyvSXSJ5CJyMvE4HV7kpmZvYbnjoD3ns8AbzFUtcaOBP6lAiWAgVVunI01gCOA4sJ7Ya22+LUZ2Kvq5kbQbrv3fgdgp6off3s0a2+RQFTgqgIkCxH5uncISW5F5PuRIRzDhp+PEIg2jArMq8BINgwHUTgTBtVYdHXxP+Cce2YkO5hZOBlPiagJpYH1JIm4J0VJcnMWStsNeZ6vqqqqZRq7kiQp0jQd5IR4M4oK/AJnRwMwmkHddAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/平台介绍.png
// module id = QNfR
// module chunks = 1